<template>
  <div>
    <div class="title">{{ $t('web_accounn_center') }}</div>
    <div class="account-list">
      <AccountFunplus :info="bindInfo.funplus_id"></AccountFunplus>
      <AccountGoogle :info="bindInfo.google"></AccountGoogle>
      <AccountFacebook :info="bindInfo.facebook"></AccountFacebook>
    </div>
  </div>
</template>

<script>
import AccountFacebook from './AccountFacebook.vue'
import AccountGoogle from './AccountGoogle.vue'
import AccountFunplus from './AccountFunplus.vue'
import { mapMutations } from 'vuex'
export default {
  name: 'Account',
  components: { AccountFacebook, AccountGoogle, AccountFunplus },
  data () {
    return {
      bindInfo: JSON.parse(window.localStorage.getItem('sdkParams') || '{}').bindinfo,
      once_key: undefined
    }
  },
  beforeCreate () {
    if (this.$utils.isQt) {
      this.$router.replace({
        name: 'Account2',
        query: this.$route.query
      })
    }
  },
  created () {
    if (!this.$utils.isQt) this.getBindInfo()
    this.$gtag.event('old_page_account', {})
  },
  methods: {
    ...mapMutations({
      setBindInfo: 'setBindInfo'
    }),
    getBindInfo () {
      this.once_key = this.$utils.getTS()
      this.$Spin.show()
      this.$socket.push({
        params: {
          action: 'get_bind_info',
          once_key: this.once_key
        },
        cb: this.getBindInfoHandler,
      })
    },
    getBindInfoHandler (resp) {
      if (resp.action !== 'get_bind_info' && resp.once_key !== this.once_key) return
      this.$Spin.hide()
      if (resp.code === 0) {
        this.setBindInfo(resp.user_info)
      } else {
        this.$msg.success(resp.code ? this.$t(`KGSDK_${resp.code}`) : this.$t('network_err'))
        this.getBindInfo()
      }
    }
  }
}
</script>

<style lang='less' scoped >
@import url('@/assets/styles/account.less');
</style>
